import { render, staticRenderFns } from "./MarkFileSave.vue?vue&type=template&id=1e262c46&scoped=true&"
import script from "./MarkFileSave.vue?vue&type=script&lang=js&"
export * from "./MarkFileSave.vue?vue&type=script&lang=js&"
import style0 from "./MarkFileSave.vue?vue&type=style&index=0&id=1e262c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e262c46",
  null
  
)

export default component.exports